import { map } from "rxjs";
import { inject, Injectable } from "@angular/core";

import { OfficialInstitution, OfficialInstitutionPayload } from "../../interfaces";

import { AuthService, Dropdown, GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class OfficialInstitutionsService
  extends HttpService
  implements HttpServiceBaseCRUD<OfficialInstitution, OfficialInstitutionPayload>
{
  private authService = inject(AuthService);
  protected get baseUrl(): string {
    return "officialinstitute/";
  }

  add(body: OfficialInstitutionPayload) {
    return this.post<OfficialInstitution>({ APIName: "add", body, showAlert: true });
  }

  update(body: OfficialInstitutionPayload) {
    return this.put<OfficialInstitution>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<OfficialInstitution>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Record<string, string | number | boolean>>) {
    return this.getPagedRequest<OfficialInstitution[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<OfficialInstitution[]>({ APIName: "getall" });
  }

  getAllDropdown() {
    return this.getAll().pipe(
      map((institutions) => {
        return institutions.map((institution) => ({
          id: institution.id,
          nameEn: institution.officialInstituteNameEn,
          nameAr: institution.officialInstituteNameAr,
          code: institution.userName,
        })) as Dropdown[];
      }),
    );
  }

  getCurrentOfficialInstitution() {
    return this.getPaged({
      pageNumber: 1,
      pageSize: 1,
      filter: { userId: this.authService.userId() ?? "" },
      orderByValue: [
        {
          colId: "CreatedDate",
          sort: "desc",
        },
      ],
    }).pipe(map((res) => (res.data ? res.data[0] : null)));
  }
}
